export const PROFILE_GET_PROFILE_BEGIN = 'PROFILE_GET_PROFILE_BEGIN';
export const PROFILE_GET_PROFILE_SUCCESS = 'PROFILE_GET_PROFILE_SUCCESS';
export const PROFILE_GET_PROFILE_FAILURE = 'PROFILE_GET_PROFILE_FAILURE';
export const PROFILE_GET_PROFILE_DISMISS_ERROR = 'PROFILE_GET_PROFILE_DISMISS_ERROR';
export const PROFILE_SET_PROFILE = 'PROFILE_SET_PROFILE';
export const PROFILE_UPDATE_BEGIN = 'PROFILE_UPDATE_BEGIN';
export const PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS';
export const PROFILE_GET_STEPS_BEGIN = 'PROFILE_GET_STEPS_BEGIN';
export const PROFILE_GET_STEPS_SUCCESS = 'PROFILE_GET_STEPS_SUCCESS';
export const PROFILE_GET_STEPS_FAILURE = 'PROFILE_GET_STEPS_FAILURE';
export const PROFILE_GET_STEPS_DISMISS_ERROR = 'PROFILE_GET_STEPS_DISMISS_ERROR';
export const PROFILE_ADD_STEP_BEGIN = 'PROFILE_ADD_STEP_BEGIN';
export const PROFILE_ADD_STEP_SUCCESS = 'PROFILE_ADD_STEP_SUCCESS';
export const PROFILE_ADD_STEP_FAILURE = 'PROFILE_ADD_STEP_FAILURE';
export const PROFILE_ADD_STEP_DISMISS_ERROR = 'PROFILE_ADD_STEP_DISMISS_ERROR';
export const PROFILE_GET_PROGRAMME_STATUS_BEGIN = 'PROFILE_GET_PROGRAMME_STATUS_BEGIN';
export const PROFILE_GET_PROGRAMME_STATUS_SUCCESS = 'PROFILE_GET_PROGRAMME_STATUS_SUCCESS';
export const PROFILE_GET_PROGRAMME_STATUS_FAILURE = 'PROFILE_GET_PROGRAMME_STATUS_FAILURE';



// WEBPACK FOOTER //
// ./src/features/profile/redux/constants.js